import { useCallback, useEffect, useState } from 'react';

import { InformationMessageDto } from 'lib_api/lib/api/gen';

import { InformationMessages } from 'hooks/DisplayMessageContext';
import { useGetInformationMessages } from 'hooks/referentiels/useRefInformationMessage';

import {
  addMessageIdToCollapsedMessagesIds,
  purgeCollapsedMessagesIds,
} from './utils';

export const useInformationMessageDisplay = () => {
  const [messages, setMessages] = useState<InformationMessages>({});
  const retrievedMessages = useGetInformationMessages();

  const addMessage = useCallback(
    (message: InformationMessageDto) => {
      setMessages(oldMessages => {
        return {
          ...oldMessages,
          [message.id]: message,
        };
      });
    },
    [setMessages],
  );

  const removeMessage = useCallback(
    (id: string) => {
      addMessageIdToCollapsedMessagesIds(id);
      setMessages(({ [id]: _, ...newMessages }) => newMessages);
    },
    [setMessages],
  );

  useEffect(() => {
    const messagesList = retrievedMessages?.referenceDtoList;
    if (messagesList) {
      purgeCollapsedMessagesIds(messagesList.map(message => message.id));
      messagesList.forEach(message => addMessage(message));
    }
  }, [retrievedMessages, addMessage]);

  return {
    messages,
    addMessage,
    removeMessage,
  };
};
